<template>
  <span>
    <b-modal
      v-model="modal"
      @show="$v.$reset()"
      @hide="hideModal"
      title="Ingresar detalles"
    >
      <div class="text-center">
        <b-alert show
          >CREANDO DESDE {{ lotComputed }}-{{ product_name }}<br /><b
            >{{ differenceComputed }} Kg RESTANTES</b
          ></b-alert
        >
      </div>

      <b-form-group>
        <label class="text-uppercase font-weight-bold">
          Orden Fabricación
        </label>
        <b-form-input
          type="text"
          required
          autocomplete="off"
          v-model="$v.form.manufacturing_order.$model"
          :state="
            $v.form.manufacturing_order.$dirty
              ? !$v.form.manufacturing_order.$error
              : null
          "
          v-on:keyup="inputSoloNumero"
        >
        </b-form-input>
      </b-form-group>

      <b-form-group>
        <label class="text-uppercase font-weight-bold" for="name"
          >Producto</label
        >
        <b-form-select
          disabled
          :options="[{ value: product_id, text: product_name }]"
          :value="product_id"
        />
      </b-form-group>
      <b-form-group>
        <label class="text-uppercase font-weight-bold" for="name"
          >Recipiente</label
        >
        <search-select
          v-model="$v.form.container.$model"
          :submitStatus="submitActive"
          :validation="$v.form.container"
          url="/bagno/container/select_container/"
        />
        <b-form-text v-if="form.container.text" class="ml-2"
          >Actualmente seleccionado:
          <b class="font-size-3">{{ form.container.text }}</b></b-form-text
        >
      </b-form-group>
      <b-form-group>
        <label class="text-uppercase font-weight-bold" for="name">
          Cantidad
          <span v-if="form.container.text"
            >{{ "de " + form.container.text }}
          </span>
        </label>
        <b-form-input
          type="text"
          required
          autocomplete="off"
          v-model="$v.form.quantity.$model"
          :state="$v.form.quantity.$dirty ? !$v.form.quantity.$error : null"
          v-on:keyup="inputSoloNumero"
          id="name"
        >
        </b-form-input>
      </b-form-group>
      <b-form-group>
        <label class="text-uppercase font-weight-bold" for="selling_unit"
          >Unidad de venta</label
        >
        <b-form-select
          v-model="$v.form.selling_unit.$model"
          :disabled="$route.params.process_type !== 'ENMALLADO'"
          :options="selling_unit_options"
        />
      </b-form-group>
      <b-row v-if="form.selling_unit === 'UN'">
        <b-col lg="6" md="6" sm="6">
          <b-form-group>
            <label class="text-uppercase font-weight-bold" for="kg_per_unit"
              >Peso por unidad</label
            >
            <b-form-input
              v-model="$v.form.kg_per_unit.$model"
              :state="
                $v.form.kg_per_unit.$dirty ? !$v.form.kg_per_unit.$error : null
              "
              type="text"
              v-on:keyup="inputSoloNumeroDecimal"
              autocomplete="off"
              id="kg_per_unit"
            >
            </b-form-input>
          </b-form-group>
        </b-col>
        <b-col lg="6" md="6" sm="6">
          <b-form-group>
            <label
              class="text-uppercase font-weight-bold"
              for="units_per_container"
            >
              Cantidad
              <span v-if="form.container.text"
                >{{ "por " + form.container.text }}
              </span>
            </label>
            <b-form-input
              v-model="$v.form.units_per_container.$model"
              :state="
                $v.form.units_per_container.$dirty
                  ? !$v.form.units_per_container.$error
                  : null
              "
              type="text"
              autocomplete="off"
              v-on:keyup="inputSoloNumero"
              id="units_per_container"
            >
            </b-form-input>
          </b-form-group>
        </b-col>
      </b-row>

      <b-form-group v-if="form.container.text !== 'BIN'">
        <label class="text-uppercase font-weight-bold" for="name"
          >Peso Pallet</label
        >
        <b-form-input
          v-model="$v.form.pallet_weight.$model"
          :state="
            $v.form.pallet_weight.$dirty ? !$v.form.pallet_weight.$error : null
          "
          type="text"
          v-on:keyup="inputSoloNumeroDecimal"
          autocomplete="off"
          id="name"
        >
        </b-form-input>
      </b-form-group>
      <b-form-group>
        <label class="text-uppercase font-weight-bold" for="name"
          >Peso Bruto</label
        >
        <b-form-input
          v-model="$v.form.gross_weight.$model"
          :state="
            $v.form.gross_weight.$dirty ? !$v.form.gross_weight.$error : null
          "
          type="text"
          v-on:keyup="inputSoloNumeroDecimal"
          autocomplete="off"
          id="name"
        >
        </b-form-input>
      </b-form-group>
      <b-form-group>
        <label class="text-uppercase font-weight-bold" for="name"
          >Peso Neto</label
        >
        <b-form-input disabled :value="nominalWeight" type="number" id="name">
        </b-form-input>
      </b-form-group>

      <template v-slot:modal-footer>
        <div class="w-100">
          <b-button
            variant="primary"
            :disabled="countIn === 0 || differenceNet <= 0"
            @click.prevent="
              e => {
                e.target.blur();
                onSubmit();
              }
            "
            @keydown="$event.keyCode === 13 ? $event.preventDefault() : false"
            class="float-right ml-1"
            >Guardar<!-- /imprimir -->
            <b-spinner v-if="loading" class="float-right" small />
          </b-button>
          <!--  <b-button class="float-right ml-1" variant="primary">Guardar</b-button> -->
          <b-button class="float-right ml-1" @click="hideModal"
            >Cancelar</b-button
          >
        </div>
      </template>
    </b-modal>
  </span>
</template>

<script>
import {
  decimal,
  integer,
  required,
  requiredIf
} from "vuelidate/lib/validators";
import { mapState, mapGetters } from "vuex";
import searchSelect from "../../searchSelect";

export default {
  name: "CreateDevolutionContent",
  props: [
    "selected",
    "lot",
    "modal",
    "lot_id",
    "product_id",
    "product_name",
    "net_kilograms_sum_in",
    "net_kilograms_sum_out"
  ],
  components: {
    searchSelect
  },
  data() {
    return {
      loading: false,
      selling_unit_options: [
        { value: "KG", text: "KG" },
        { value: "UN", text: "UN" }
      ],
      form: {
        product: this.product_id,
        quantity: 0,
        selling_unit: "KG",
        kg_per_unit: 0,
        units_per_container: 0,
        pallet_weight: 0,
        gross_weight: null,
        container: {
          text: null,
          material_weight: null
        },
        manufacturing_order: null
      },
      submitActive: false
    };
  },
  watch: {
    socketWeight(newValue, oldValue) {
      this.form.gross_weight = newValue;
    }
  },
  computed: {
    ...mapState("socketModule", ["socketWeight", "connected"]),
    ...mapGetters("bagnoProcessModule", [
      "countIn",
      "countOut",
      "differenceNet",
      "checkBrechaComercial",
      "currentLotInProcess",
      "currentProductsInProcess"
    ]),
    netWeight() {
      return (
        this.form.gross_weight -
        this.form.pallet_weight -
        this.form.quantity * this.form.container.material_weight
      ).toFixed(2);
    },
    nominalWeight() {
      if (this.form.selling_unit === "UN") {
        return (
          this.form.quantity *
          this.form.kg_per_unit *
          this.form.units_per_container
        );
      } else {
        return this.netWeight;
      }
    },
    lotComputed() {
      return this.lot;
    },
    lotId() {
      return this.lot_id;
    },
    productId() {
      return this.product_id;
    },
    differenceComputed() {
      return (this.net_kilograms_sum_in - this.net_kilograms_sum_out).toFixed(
        2
      );
    }
  },
  methods: {
    hideModal() {
      this.$emit("hideReturnModal");
    },
    resetForm() {
      this.form.quantity = null;
      this.form.pallet_weight = 0;
      this.form.gross_weight = null;
      this.form.manufacturing_order = null;
    },
    async addRowsOut() {
      const thisV = this;
      thisV.loading = true;
      let d = new Date().getTime();
      let n = thisV.countOut + 1;
      const data = {
        number: d + "P" + n,
        product: { id: thisV.product_id }, // endpoint requires product object --> product_id=data['product']['id'],
        quantity: parseInt(thisV.form.quantity),
        selling_unit: thisV.form.selling_unit,
        kg_per_unit: thisV.form.kg_per_unit,
        units_per_container: parseInt(thisV.form.units_per_container),
        gross_kilograms: parseFloat(thisV.form.gross_weight),
        container: thisV.form.container,
        net_kilograms: parseFloat(thisV.nominalWeight),
        lot: thisV.lot_id,
        process: thisV.$route.params.id,
        lot_id: thisV.lotId, // lote de referencia
        product_id: thisV.productId, // producto de referencia
        is_devolution: true,
        manufacturing_order: parseInt(thisV.form.manufacturing_order)
      };
      if (
        parseFloat(thisV.nominalWeight) > parseFloat(this.differenceComputed)
      ) {
        thisV.$toast.info(
          "kilos ingresados superan el total de kilos restantes disponible en el lote",
          ""
        );
        thisV.loading = false;
        thisV.submitStatus = false;
      } else {
        try {
          const response = await thisV.$axios({
            method: "POST",
            url: "/bagno/content/create_process_content/",
            data: data
          });
          thisV.hideModal();
          thisV.resetForm();
          thisV.$store.dispatch("bagnoProcessModule/addRowsOut", response.data);
          thisV.$toast.success("Agregado con éxito", "");
          thisV.loading = false;
          thisV.submitActive = false;
        } catch (error) {
          thisV.hideModal();
          thisV.resetForm();
          thisV.$toast.error("Problemas al crear proceso", "");
          thisV.loading = false;
          thisV.submitActive = false;
        }
      }
    },
    onSubmit(evt) {
      this.$v.form.$touch();
      this.submitActive = true;
      if (this.$v.$invalid) {
        this.$toast.info("Campos restantes en el formulario", "");
      } else {
        if (this.nominalWeight >= 0) {
          this.addRowsOut();
        } else {
          this.$toast.info("El campo peso neto no puede ser negativo", "");
        }
      }
    },
    inputSoloNumero(event) {
      event.target.value = event.target.value.replace(/[^0-9]/, "");
    },
    inputSoloNumeroDecimal(event) {
      event.target.value = event.target.value.replace(/[^0-9.]/, "");
    }
  },
  validations: {
    form: {
      quantity: { required, integer },
      pallet_weight: { required },
      // container: {required},
      container: {
        text: { required },
        material_weight: { required }
      },
      gross_weight: { required },
      selling_unit: { required },
      manufacturing_order: { required },
      kg_per_unit: {
        required: requiredIf(function() {
          return this.form.selling_unit === "UN";
        })
      },
      units_per_container: {
        required: requiredIf(function() {
          return this.form.selling_unit === "UN";
        })
      }
    }
  }
};
</script>

<style scoped></style>
